import { StarIcon } from '@phosphor-icons/react'
import { EmptyState } from '@/components/ui/EmptyState'
import Icons from '@/components/Icons'
import { Icon } from '@/components/ui/Icon'
import { useAuth } from '@/app/auth/AuthContext'
import { useAverageScoreQuery } from '@/hooks/api/queries'
import { RequestState } from '@/components/ui/RequestState'
import { digitsEnToFa } from '@persian-tools/persian-tools'
import styles from './OrdersRating.module.css'

export function OrdersRating() {
  const { user } = useAuth()
  const query = useAverageScoreQuery(Boolean(user))
  const avg = query.data?.averageScore
  const score = typeof avg === 'number' && Number.isFinite(avg) && avg !== 0 ? avg.toFixed(1) : null
  const rounded = score == null ? null : Number(score)
  // Preserve the original rating thresholds, which use the displayed rounded score.
  const emotion = rounded == null ? 'emojiNull' : rounded >= 4.1 ? 'emojiVeryHappy' : rounded >= 4 ? 'emojiHappy' : rounded >= 3.8 ? 'emojiNormal' : 'emojiSad'
  const sentimentLabel = rounded == null ? 'بدون امتیاز' : rounded >= 4.1 ? 'بسیار راضی' : rounded >= 4 ? 'راضی' : rounded >= 3.8 ? 'رضایت متوسط' : 'ناراضی'

  if (query.isPending) return <RequestState kind="loading" title="در حال دریافت امتیاز" />
  if (query.isError && query.data === undefined) return <RequestState kind="error" title="امتیاز دریافت نشد." onRetry={() => { void query.refetch() }} />

  return <section className={styles.rating} aria-label={score == null ? 'بدون امتیاز' : `امتیاز ${digitsEnToFa(score)} از ۵`}>
    {score == null ? <EmptyState density="compact" title="امتیازی برای نمایش موجود نیست." artwork={<Icons name={emotion} size={40} aria-hidden="true" />} /> : <>
      <div className={styles.summary}>
        <div className={styles.details}>
          <p className={styles.label}>میانگین امتیاز شما</p>
          <div className={styles.stars} aria-hidden="true">
            {Array.from({ length: 5 }, (_, index) => <span className={styles.star} key={index}>
              <Icon as={StarIcon} weight="fill" size={20} />
              <span className={styles.starFill} style={{ width: `${Math.min(1, Math.max(0, (rounded ?? 0) - index)) * 100}%` }}><Icon as={StarIcon} weight="fill" size={20} /></span>
            </span>)}
          </div>
        </div>
        <div className={styles.score}><b>{digitsEnToFa(score)}</b><span>از ۵</span></div>
      </div>
      <div className={styles.sentiment}>
        <span>وضعیت رضایت</span>
        <span className={styles.emotion} role="img" aria-label={sentimentLabel}><Icons name={emotion} size={36} aria-hidden="true" /></span>
      </div>
    </>}
  </section>
}
